export { default as TopLevelComponent } from './top-level-component';
